import { BaseService } from '@services/BaseService'

const resource = 'hr/immunization'

class ImmunizationService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const immunizationService = new ImmunizationService()
